import isEmail from 'validator/lib/isEmail';
import validatorIsEmpty from 'validator/lib/isEmpty';
import isUrl from 'validator/lib/isURL';
import trim from 'validator/lib/trim';

const isEmpty = (value?: string) => !value || validatorIsEmpty(trim(value));

export const empty = (message: string) => (value: string) => isEmpty(value) ? message : undefined;
export const required = empty('Required');
export const nameEmpty = empty('Enter your name');
export const emailEmpty = empty('Enter your email address');
export const websiteEmpty = empty('Enter your website / project name');
export const passwordEmpty = empty('Enter your password');
export const messageEmpty = empty('Tell us how we can help');
export const useCaseEmpty = empty('Tell us about your use case');

export const email = (value: string) =>
  !isEmpty(value) && !isEmail(trim(value)) ? 'Please enter a valid email address' : undefined;
export const adminEmail = (value: string) =>
  value.length > 0 && !isEmail(trim(value)) ? 'Please enter a valid email address' : undefined;
export const domain = (value: string) =>
  !isEmpty(value) && !isUrl(trim(value)) ? 'Invalid domain format' : undefined;
export const estimatedTraffic = (value: string) =>
  !isEmpty(value) ? undefined : 'Select your estimated traffic';
export const passwordStrength = (value: string) =>
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/.test(value)
    ? undefined
    : 'Please choose a stronger password. Try a mix of lower/upper case letters and numbers.';
export const passwordLength = (value: string) =>
  !isEmpty(value) && trim(value).length < 12
    ? 'Your password must be at least 12 characters'
    : undefined;
